import { ActionType } from '../../constants/ActionTypes'

export default function offersReducer(state = {}, action = {}) {
    switch (action.type) {
        case ActionType.GET_OFFERS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                offersList: action.payload.resetData ? action.payload.offersList : [...state.offersList, ...action.payload.offersList],
                hasNext: action.payload.hasNext
            }
        case ActionType.GET_OFFERS_LOADING:
            return {
                ...state,
                isLoading: action.payload
            }
        case ActionType.GET_OFFERS_LOADING:
            return {
                ...state,
                itemLoading: action.payload
            }
        case ActionType.GET_OFFERS_ITEM_SUCCESS:
            return {
                ...state,
                itemLoading: false,
                itemDetails: action.payload
            }
        case ActionType.GET_OFFER_PRODUCTS_SUCCESS:
            return {
                ...state,
                offerProducts: action.payload.resetData ? action.payload.data : {...state.offerProducts, entries: [...state.offerProducts.entries, ...action.payload.data.entries], hasNext: action.payload.data.hasNext, gameCount: action.payload.data.gameCount},
            }
        case ActionType.GET_JOINED_CAMPAIGNS_SUCCESS:
            return {
                ...state,
                joinedCampaigns: (action.payload.loadMore && state.joinedCampaigns) ? [...state.joinedCampaigns, ...action.payload.data] : action.payload.data
            }
        default:
            return state;
    }
}

